import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const RankingSkeleton = () => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(5).fill(0);
  return (
    <View
      style={{
        flexDirection: "column",
        width: "100%",
        gap: 10,
        paddingTop: 12,
        paddingBottom: 35,
      }}
    >
      {skeletonCards.map((index) => (
        <Skeletons height={50} width={"100%"} style={{ borderRadius: 14 }} />
      ))}
    </View>
  );
};

export default RankingSkeleton;
